export type LeadSourceKind =
  | "instagram"
  | "facebook"
  | "whatsapp"
  | "youtube"
  | "email"
  | "walk-in"
  | "referral"
  | "manual"
  | "phone"
  | "website"
  | "other";

export type LeadSourceDescriptor = {
  kind: LeadSourceKind;
  label: string;
};

export type InstagramSourceChannel = "dm" | "comment";

export function resolveInstagramSourceChannel(source: unknown): InstagramSourceChannel | null {
  const normalized = String(source || "").trim().toLowerCase().replace(/['’]/g, "").replace(/[_-]+/g, " ").replace(/\s+/g, " ");
  if (!normalized.includes("instagram")) return null;
  if (normalized.includes("comment")) return "comment";
  if (normalized.includes("dm") || normalized.includes("direct message")) return "dm";
  return null;
}

export function resolveLeadSource(source: unknown): LeadSourceDescriptor {
  const label = String(source || "").trim() || "Other";
  const normalized = label.toLowerCase().replace(/['’]/g, "").replace(/[_-]+/g, " ").replace(/\s+/g, " ");

  if (normalized.includes("instagram")) return { kind: "instagram", label };
  if (normalized.includes("facebook") || normalized === "messenger") return { kind: "facebook", label };
  if (normalized.includes("whatsapp") || normalized.includes("whats app")) return { kind: "whatsapp", label };
  if (normalized.includes("youtube")) return { kind: "youtube", label };
  if (normalized.includes("outlook") || normalized === "email") return { kind: "email", label };
  if (normalized.includes("walk in") || normalized.includes("walkin")) return { kind: "walk-in", label };
  if (normalized.includes("referral") || normalized.includes("referal")) return { kind: "referral", label };
  if (normalized.includes("manual")) return { kind: "manual", label };
  if (normalized.includes("phone") || normalized === "call") return { kind: "phone", label };
  if (normalized.includes("website") || normalized === "web") return { kind: "website", label };
  return { kind: "other", label };
}
